module.exports = __webpack_public_path__ + "static/media/playVideo1.c4988011.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/theme/components/images/playVideo1.png
// module id = 974
// module chunks = 0